import { gql } from '@apollo/client';

export default gql`
  mutation DeleteFolder($id: Int!) {
    deleteFolderById(input: { id: $id }) {
      deletedFolderId
    }
  }
`;
